import { capitalizeFirstLetter } from "@helperFunctions/capitalizeFirstLetter";
import { TSortingModel } from "../../types/apiRequest/TSortingModel";

export const getSortingUrlParams = (sorting: TSortingModel): string => {
  return encodeURIComponent(
    `${capitalizeFirstLetter(sorting?.[0]?.field)} ${sorting?.[0]?.sort}`
  );
};
